import { FC, ReactNode, useMemo } from 'react'
import styles from 'components/features/creditCard/creditCardOnboarding/ReadOnlyField/ReadOnlyField.styl'
import Button from 'components/features/pfm/Button/Button'
import cn from 'classnames'
import { QAMarked } from 'interfaces/component'
import Spinner from 'components/features/pfm/Spinner/Spinner'

const PASS_THRU = (value: string) => value

type ReadOnlyFieldProps = QAMarked & {
  label: ReactNode
  values: string[]
  className?: string
  isLoading?: boolean
  maskValue?: (value: string) => string
  onEdit?: () => void
}
export const ReadOnlyField: FC<ReadOnlyFieldProps> = (props) => {
  const { label, values, onEdit, className, isLoading, maskValue = PASS_THRU, qaMarker } = props

  const valuesChild = useMemo(() => values.map((value, index) => (
    <div key={ index } className={ styles.value } data-qa-marker='value' data-qa-type={ index }>
      { maskValue(`${ value }`) }
    </div>
  )), [maskValue, values])

  return (

    <div className={ cn(styles.readOnlyField, className, isLoading && styles.isLoading) } data-qa-marker={ qaMarker }>
      <div className={ styles.label } data-qa-type='label'>{ label }</div>
      <div className={ styles.cols }>
        <div className={ styles.values } data-qa-marker='values'>
          { valuesChild }

        </div>
        { isLoading && (
          <div className={ styles.preloader } data-qa-marker='preloader'>
            <Spinner size='medium' />
          </div>
        )}
        { onEdit && !isLoading && (
          <div className={ styles.cta }>
            <Button style='textOnly' fullWidth size='micro' onClick={ onEdit } qaMarker='edit'>
              EDIT
            </Button>
          </div>
        )}
      </div>
    </div>
  )

}
